module.exports = __webpack_public_path__ + "static/media/filter.0b98a4a7.svg";